import { render } from "./PdfViewer.vue?vue&type=template&id=15197d11&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=15197d11&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15197d11"

export default script